/**
 * tooltip_controller.js — thin Stimulus wrapper around a Bootstrap tooltip.
 *
 * Bootstrap 5 tooltips need an explicit `new bootstrap.Tooltip(el)` call per
 * element (unlike modals/dropdowns, `data-bs-toggle="tooltip"` alone does
 * nothing). This controller owns that lifecycle so the instance is disposed
 * in disconnect() -- Turbo replaces <body> on navigation, and an undisposed
 * tooltip instance leaks its popper + event listeners.
 *
 * Usage: data-controller="tooltip" data-bs-toggle="tooltip" title="...".
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this._tooltip = window.bootstrap ? new window.bootstrap.Tooltip(this.element) : null;
    }

    disconnect() {
        this._tooltip?.dispose();
        this._tooltip = null;
    }
}
